var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expandable-container",class:{
		'is-active': _vm.expanded,
		'expandable-container--overflow' : _vm.transitioning || !_vm.expanded,
		'hide': !_vm.expanded && !_vm.transitioning
	},style:(`max-height: ${_vm.height};`),attrs:{"aria-hidden":!_vm.expanded},on:{"transitionstart":_vm.transitionStart,"transitionend":_vm.transitionEnd}},[_c('div',{ref:"content"},[(_vm.alwaysRender || _vm.expanded || _vm.transitioning)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }